var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RNavBucks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,10 L33,10 L33,15 C33,19.7 29,23.7 24,23.7 C19,23.7 15,19.7 15,15 Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23.5 L30,23.5 L30,28 L35,28 L35,31 L13,31 L13,28 L18,28 Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2,31.2 L29.8,31.2 L31.5,37 L16.5,37 Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13.5 L25.3,17.1 L29,17.1 L26.1,19.1 L27.2,22.4 L24,20.4 L20.8,22.4 L21.9,19.1 L19,17.1 L22.7,17.1 Z",
    fill: "#FFD000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1,14.4 C10.1,14.6 9,15.8 9,17.6 C9,20.3 11.3,22.3 15,22.5 L15,19.7 C13.2,19.4 12,18.7 12,17.7 C12,17 12.6,16.4 13.6,16.2 Z",
    fill: "#7C1CFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35,19.7 C36.8,19.4 38,18.7 38,17.7 C38,17 37.4,16.4 36.4,16.2 L36.4,14.4 C38.4,14.6 39.5,15.8 39.5,17.6 C39.5,20.3 37.2,22.3 33.5,22.5 L33.5,19.7 Z",
    fill: "#00D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RNavBucks);
export default __webpack_public_path__ + "static/media/p4r_nav_bucks.110f310530d67a1dc7ad3d6f5806f519.svg";
export { ForwardRef as ReactComponent };